// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"RmdlV","item":"t1M39","toiplusLogo":"Hihi4","toiplusLogo_perp":"qxUTg","text_info":"yYex9"};